<template>
    <div class="chatbot-tune-preview">
        <div class="tune-plugin">
            <div class="plugin-wrapper">
                <div class="plugin-header">
                    <div class="avatar">
                        <SupsisSVG />
                        <div class="indicator"></div>
                    </div>
                    <div class="title">
                        <div class="name">{{ companyName }}</div>
                        <div class="status">Online</div>
                    </div>
                </div>
                <div class="plugin-content">
                    <div class="welcome">
                        {{ welcomeText }}
                    </div>
                    <div class="reply-list">
                        <div class="reply">FAQ</div>
                        <div class="reply">About Recruitee</div>
                        <div class="reply">Pricing</div>
                        <div class="reply">Contact Us</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SupsisSVG from "./SupsisSVG.vue";

export default Vue.extend({
    name: "ChatbotTunePreview",
    components: { SupsisSVG },
    props: {
        companyName: {
            type: String,
            default: "Company",
        },
        welcomeText: {
            type: String,
            default: "Welcome to website. I am  digital assistant 🤖. How can I help you?",
        },
    },
});
</script>

<style scoped lang="scss">
.tune-plugin {
    background: radial-gradient(circle, #e0e3f9 30%, #9fa7e7 100%);
    border-radius: 20px;
    flex-shrink: 0;
    height: 508px;
    margin-left: 30px;
    max-width: 100%;
    position: sticky;
    top: 111px;
    width: 427px;
    display: flex;
    flex-direction: column;

    .plugin-wrapper {
        background: #fff;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.2);
        height: 435.82px;
        margin-left: auto;
        margin-right: auto;
        margin-top: auto;
        overflow: hidden;
        padding-top: 17px;
        width: 330px;
        display: flex;
        flex-direction: column;

        .plugin-header {
            display: flex;
            margin-bottom: 36px;
            padding-left: 26px;
            padding-right: 26px;

            .avatar {
                display: flex;
                align-items: center;
                background: linear-gradient(201.22deg, #e19c5d -20.71%, #380de4 86.01%);
                border-radius: 100%;
                height: 40px;
                justify-content: center;
                margin-right: 11px;
                position: relative;
                width: 40px;
            }

            .indicator {
                background: #29e131;
                border: 2px solid #fff;
                border-radius: 100%;
                bottom: -1px;
                height: 11px;
                position: absolute;
                right: -1px;
                width: 11px;
            }

            .title {
                display: flex;
                flex-direction: column;

                .name {
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 20px;
                }

                .status {
                    color: #979797;
                    font-size: 12px;
                    line-height: 16px;
                }
            }
        }

        .plugin-content {
            display: flex;
            align-items: center;
            flex-direction: column;
            height: 100%;
            overflow: auto;
            padding-left: 26px;
            padding-right: 26px;

            .welcome {
                align-self: flex-start;
                background-color: #006cff;
                border-radius: 17px;
                color: #fff;
                max-width: 100%;
                padding: 12px;
                text-align: left;
                min-height: 60px;
                width: stretch;
            }

            .reply-list {
                display: flex;
                margin-top: 15px;
                align-items: center;
                flex-direction: column;

                .reply {
                    border: 1px solid #006cff;
                    border-radius: 20px;
                    color: #006cff;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 18px;
                    margin-bottom: 10px;
                    padding: 4px 15px;
                    width: max-content;
                }
            }
        }
    }
}
</style>
